import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/cadastro/$id/editar')({
  component: lazyRouteComponent(
    () => import('@/features/cadastro/components/editar-cliente-page'),
    'EditarClientePage'
  ),
})
